import type { NetworkLifecycleCallbacks, NetworkStatusInput, NetworkStatusPayload } from "./types";

export function buildNetworkStatusPayload(input: NetworkStatusInput): NetworkStatusPayload {
  return {
    ...input,
    updatedAt: Date.now(),
  };
}

export function emitNetworkStatus(callbacks: NetworkLifecycleCallbacks | undefined, input: NetworkStatusInput): void {
  callbacks?.onStateChange?.(buildNetworkStatusPayload(input));
}
